import { render, staticRenderFns } from "./AssociatedCasesBadge.vue?vue&type=template&id=72f73b01&scoped=true&"
import script from "./AssociatedCasesBadge.vue?vue&type=script&lang=js&"
export * from "./AssociatedCasesBadge.vue?vue&type=script&lang=js&"
import style0 from "./AssociatedCasesBadge.vue?vue&type=style&index=0&id=72f73b01&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f73b01",
  null
  
)

export default component.exports